/** @format */

import React from "react";

export function ChatListItemSkeleton() {
  return (
    <div
      className="px-4 py-3 mb-4 rounded-xl border-[1.5px] border-[#E4E7EC] bg-white animate-pulse"
      aria-hidden
    >
      <div className="flex justify-between items-start mb-2 gap-2">
        <div className="h-4 bg-[#E4E7EC] rounded flex-1 max-w-[70%]" />
        <div className="h-3 bg-[#F2F4F7] rounded w-10 flex-shrink-0" />
      </div>
      <div className="h-3 bg-[#F2F4F7] rounded w-full" />
    </div>
  );
}

export function ChatListLoadingSkeleton({ rows = 5 }) {
  return (
    <div className="px-3 py-3">
      {Array.from({ length: rows }).map((_, i) => (
        <ChatListItemSkeleton key={i} />
      ))}
    </div>
  );
}

export default ChatListItemSkeleton;
